<template>
  <router-view class="h-100"/>
</template>

<script>
import {mapActions,mapState} from 'vuex';
import {auth} from '@/firebase.js';
export default {
	methods:{
		...mapActions(['getPerfil','logoutUsuario'])
	},
	computed:{
		...mapState(['menu','usuario'])
	},
  	created(){
	  	var that = this;
	  	auth.onAuthStateChanged(function(user) {
	      if (user) {
	      	console.log('IniciadoSesion');
	      	if (that.usuario.id==null) {
	      		console.log('IniciadoSesion2');
	      		that.getPerfil(localStorage.id_usuario_cliente_imperia);
	      	}else{
	      		console.log('IniciadoSesion3');
	      		localStorage.id_usuario_cliente_imperia=that.usuario.id;
	        	that.$router.push({name:'Dashboard'});
	      	}
	      } else {
	        that.logoutUsuario();
	        if (that.$route.name!='Cliente') {
	          that.$router.push({name:'Cliente'});
	        }
	        that.menu.ready=true;
	      }
	    });
  	}
};
</script>

<style>
html {
  height: 100%;
}
body {
  min-height: 100%;
}
.li_inactiva{
	color:#1f2d41 !important;
}
.li_active{
	color:#69027d !important;
}
.bg-innovation{
	background-color: #69027d !important;
}
.text-innovation{
	color: #69027d !important;
}
.btn-innovation{
	background-color: #69027d !important;
	color:white !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue